import React from "react";

export function Logo({ className }: { className?: string}) {
  const classNames = className ? `logo-img ${className}` : "logo-img";
  return (
      <img src="/logos/DemoTime_Logo.png" className={classNames} width={200} height={35} />
  );
}
